import {ReactNode} from 'react';

import GuestGuard from '@/components/layouts/guard/GuestGuard';
import AuthGuard from '@/components/layouts/guard/AuthGuard';
import Loader from '@/components/ui/loader';

type GuardProps = {
    authGuard: boolean;
    guestGuard: boolean;
    children: ReactNode;
};

const Guard = ({children, authGuard, guestGuard}: GuardProps) => {
    if (guestGuard) {
        return <GuestGuard fallback={<Loader/>}>{children}</GuestGuard>;
    } else if (!guestGuard && !authGuard) {
        return <>{children}</>;
    } else {
        return <AuthGuard fallback={<Loader/>}>{children}</AuthGuard>;
    }
};

export default Guard;
